var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBfIconSmm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 100,
    viewBox: "0 0 100 100",
    width: 100,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m100 50a50 50 0 1 1 -50-50 50 50 0 0 1 50 50zm-27.6 10.59c2.45-2.23 2.44-3.66.4-7a1.29 1.29 0 0 1 -.07-1.15 10.48 10.48 0 0 0 1.21-3.44 5.81 5.81 0 0 0 -1.24-4.2c-.23-.25-1.09-1.16-4.2-1.74a27.7 27.7 0 0 0 -6.34-.28c-4.32.11-6 .35-6.59-.62-.19-.33-.32-.75.09-1.8.72-1.86 1.57-3.67 2.42-5.47 1.68-3.53 2.4-6.17 1.07-10-.89-2.57-2-3.63-4.4-3.15s-2.75 2.26-2.84 4.41c-.16 3.69-1 6-4.41 8.43-4.06 2.91-8 6.78-10.08 11.4a4.71 4.71 0 0 1 -2.34 2.72 2.58 2.58 0 0 0 -1.65 2.37v17.81c0 1 0 2.58.05 3.88a2.63 2.63 0 0 0 2.35 2.57l3.47.37c13.56 1.4 13.56 1.13 23.38.85 5.21-.4 6.61-1.36 7.06-6.26a1.78 1.78 0 0 1 .48-1.15c2.74-2 3.47-4.31 1.92-7a1.25 1.25 0 0 1 .26-1.55zm-43.48-10.82h-.45a2.77 2.77 0 0 0 -2.76 2.76v19.73a2.77 2.77 0 0 0 2.76 2.74h.45a2.76 2.76 0 0 0 2.75-2.76v-19.71a2.76 2.76 0 0 0 -2.75-2.76z",
    fill: "#065296"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBfIconSmm);
export default __webpack_public_path__ + "static/media/bf-icon-smm.22da35bee95f5363c4ed6f3af1bf2b9a.svg";
export { ForwardRef as ReactComponent };